module.exports = __webpack_public_path__ + "static/media/react.fed3fd1c.png";